export default "__VITE_ASSET__D01ftRS3__"